import React from 'react';
import { useDetail } from '../context/DetailContext';
import { Play, Plus, Check, Star } from 'lucide-react';
import { useApp } from '../context/AppContext';

const OriginalCard = ({ show, variant = 'poster', progress }) => {
  const { openShow } = useDetail();
  const { profile } = useApp();
  const isBackdrop = variant === 'backdrop';
  const img = isBackdrop ? (show.backdrop_url || show.poster_url) : show.poster_url;
  const progressPct = typeof progress === 'number' && progress > 0.01 && progress < 0.98
    ? Math.max(3, Math.round(progress * 100))
    : 0;
  return (
    <button onClick={() => openShow(show)}
      className={`tv-focusable relative flex-shrink-0 ${isBackdrop ? 'w-[340px] h-[190px]' : 'w-[200px] h-[300px]'} rounded-xl overflow-hidden bg-white/5 card-shine text-left`}>
      <img src={img} alt={show.title} loading="lazy" className="w-full h-full object-cover" />
      <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-[9px] font-bold tracking-widest bg-[#E50914] text-white">BLUNT</span>
      <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-black/95 via-black/40 to-transparent">
        <div className="text-[11px] text-white/75 mb-1">{show.year || ''} {show.creator_name ? `• ${show.creator_name}` : ''}</div>
        <div className="text-[13px] font-semibold line-clamp-2 text-white">{show.title}</div>
      </div>
      {progressPct > 0 && (
        <div className="absolute left-0 right-0 bottom-0 h-1 bg-black/60">
          <div className="h-full bg-[#E50914]" style={{ width: `${progressPct}%` }} />
        </div>
      )}
    </button>
  );
};

export default OriginalCard;
